"use client";

/**
 * FrenFlow user badge — logo-only chip with a native tooltip.
 * Used in traders grid, trader profiles, and top holders table.
 */
export default function FrenFlowBadge({ size = "sm" }: { size?: "sm" | "md" }) {
  const imgSize = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5";
  const padding = size === "sm" ? "p-[3px]" : "p-1";

  return (
    <span
      className={`inline-flex items-center ${padding} rounded-[5px] bg-[#CCFF00]/10 border border-[#CCFF00]/30 flex-shrink-0 cursor-default`}
      title="FrenFlow User"
    >
      <img
        src="/brand/frenflow_logo.png"
        alt=""
        className={`${imgSize} rounded-sm flex-shrink-0`}
      />
    </span>
  );
}
